import PropTypes from 'prop-types';

import { styled } from '@mui/material';

import { renderedComponentPropType } from '@libs/propTypes';
import ThemeToggle from '../../../app/Theme/ThemeToggle';

const propTypes = {
    adornments: PropTypes.arrayOf(renderedComponentPropType),
};

const defaultProps = {
    adornments: [],
};

const Container = styled('div')(({ theme: { palette, spacing } }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'transparent',
    marginRight: spacing(2),
}));

const EndAdornment = ({ adornments }) => {
    return (
        <Container>
            <ThemeToggle />
            {adornments.map((Adornment, index) => (
                <div key={`appBar-adornment${index}`}>
                    <Adornment />
                </div>
            ))}
        </Container>
    );
};

EndAdornment.propTypes = propTypes;
EndAdornment.defaultProps = defaultProps;

export default EndAdornment;
